export default __webpack_public_path__ + "media/images/dashboard_icons/qrcode-2a6418191ba37997e9429a0ff409d807.svg";